(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sleke-app-search"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var MAX_RENDER = 240;
    var CACHE_TTL_MS = 12 * 60 * 60 * 1000;
    var CACHE_VERSION = 'v1';

    function create(tag, cls, text) {
      var el = document.createElement(tag);
      if (cls) el.className = cls;
      if (text) el.textContent = text;
      return el;
    }

    function fsUnwrap(v) {
      if (v == null) return '';
      if (v.stringValue != null) return v.stringValue;
      if (v.integerValue != null) return String(v.integerValue);
      return '';
    }

    function pickName(x) {
      if (typeof x === 'string') return x;
      if (!x || typeof x !== 'object') return '';
      if (x.fields && typeof x.fields === 'object') {
        var f = x.fields;
        var keys = ['name', 'title', 'appName', 'label', 'displayName'];
        for (var i = 0; i < keys.length; i++) {
          if (f[keys[i]]) { var s = fsUnwrap(f[keys[i]]); if (s) return s; }
        }
        for (var k in f) { if (f[k] && f[k].stringValue) return f[k].stringValue; }
        return '';
      }
      return x.name || x.title || x.appName || x.label || x.displayName || '';
    }

    function extract(data) {
      var arr = Array.isArray(data)
        ? data
        : (data && (data.documents || data.apps || data.items || data.results)) || [];
      var out = [];
      for (var i = 0; i < arr.length; i++) {
        var name = String(pickName(arr[i]) || '').trim().replace(/\.apk$/i, '');
        if (name) out.push(name);
      }
      return out;
    }

    function finalize(arr) {
      var seen = {};
      var out = [];
      for (var i = 0; i < arr.length; i++) {
        var key = arr[i].toLowerCase();
        if (seen[key]) continue;
        seen[key] = true;
        out.push(arr[i]);
      }
      out.sort(function (a, b) { return a.localeCompare(b); });
      return out;
    }

    function stripToken(u) {
      return u.replace(/([?&])pageToken=[^&]*/g, '$1').replace(/[?&]+$/, '').replace(/([?&])&+/g, '$1');
    }

    function withToken(u, token) {
      var base = stripToken(u);
      var sep = base.indexOf('?') === -1 ? '?' : '&';
      return base + sep + 'pageToken=' + encodeURIComponent(token);
    }

    function readCache(key) {
      try {
        var raw = window.localStorage.getItem(key);
        if (!raw) return null;
        var obj = JSON.parse(raw);
        if (!obj || !obj.t || !Array.isArray(obj.v)) return null;
        if (Date.now() - obj.t > CACHE_TTL_MS) return null;
        return obj.v;
      } catch (e) { return null; }
    }

    function writeCache(key, list) {
      try { window.localStorage.setItem(key, JSON.stringify({ t: Date.now(), v: list })); } catch (e) {}
    }

    function init(root) {
      var input = root.querySelector('[data-app-input]');
      var clearBtn = root.querySelector('[data-app-clear]');
      var grid = root.querySelector('[data-app-grid]');
      var statusEl = root.querySelector('[data-app-status]');
      var emptyEl = root.querySelector('[data-app-empty]');
      if (!input || !grid || !statusEl || root.dataset.appSearchReady) return;
      root.dataset.appSearchReady = 'true';

      var endpoint = (root.getAttribute('data-endpoint') || '').trim();
      var collapse = root.getAttribute('data-collapse') !== 'false';
      var fallback = [];
      try { fallback = JSON.parse(root.getAttribute('data-fallback') || '[]'); } catch (e) {}
      var all = [];
      var timer = null;
      var cacheKey = 'sleke-apps:' + CACHE_VERSION + ':' + endpoint;

      function render(items, query) {
        var shown = items.length > MAX_RENDER ? items.slice(0, MAX_RENDER) : items;
        grid.textContent = '';
        for (var i = 0; i < shown.length; i++) {
          var li = create('li', 'sleke-app-search__card');
          li.appendChild(create('span', 'sleke-app-search__name', shown[i]));
          grid.appendChild(li);
        }
        grid.hidden = shown.length === 0;
        if (emptyEl) emptyEl.hidden = !(query && items.length === 0);

        if (!query) {
          statusEl.textContent = all.length
            ? all.length + ' apps available — start typing to search'
            : '';
        } else if (items.length === 0) {
          statusEl.textContent = 'No matches';
        } else {
          var label = items.length === 1 ? '1 match' : items.length + ' matches';
          if (items.length > MAX_RENDER) label += ' — showing first ' + MAX_RENDER + ', keep typing to narrow';
          statusEl.textContent = label;
        }
      }

      function apply() {
        var q = (input.value || '').trim().toLowerCase();
        if (clearBtn) clearBtn.hidden = q.length === 0;
        if (!q && collapse) { render([], ''); return; }
        var items = q
          ? all.filter(function (name) { return name.toLowerCase().indexOf(q) !== -1; })
          : all;
        render(items, q);
      }

      input.addEventListener('input', function () {
        if (timer) clearTimeout(timer);
        timer = setTimeout(apply, 150);
      });

      if (clearBtn) {
        clearBtn.addEventListener('click', function () {
          input.value = '';
          apply();
          input.focus();
        });
      }

      function ready(list) {
        all = list;
        apply();
      }

      function useFallback(msg) {
        if (fallback.length) { ready(finalize(extract(fallback))); }
        else if (msg) { statusEl.textContent = msg; }
      }

      statusEl.textContent = 'Loading app list…';
      if (!endpoint) {
        useFallback('App search is being wired up — check back soon.');
        return;
      }

      var cached = readCache(cacheKey);
      if (cached && cached.length) { ready(cached); return; }

      var collected = [];
      function step(u, pages) {
        return fetch(u, { headers: { Accept: 'application/json' } })
          .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.json(); })
          .then(function (d) {
            collected = collected.concat(extract(d));
            var token = d && d.nextPageToken;
            if (token && pages < 40) return step(withToken(endpoint, token), pages + 1);
            return collected;
          });
      }

      step(endpoint, 0)
        .then(function (list) {
          var finalList = finalize(list);
          if (finalList.length) writeCache(cacheKey, finalList);
          ready(finalList);
        })
        .catch(function () { useFallback('App search is temporarily unavailable.'); });
    }

    function initAll() {
      document.querySelectorAll('[data-sleke-app-search]').forEach(init);
    }

    initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
